import { render } from "./AuthenticateView.vue?vue&type=template&id=204ff9a0&scoped=true"
import script from "./AuthenticateView.vue?vue&type=script&lang=js"
export * from "./AuthenticateView.vue?vue&type=script&lang=js"

import "./authenticate.scss?vue&type=style&index=0&id=204ff9a0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204ff9a0"]])

export default __exports__